import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, ElementRef } from '@angular/core';
import { AutoUnsubscribe } from '../../../../core/decorators/auto-unsubscribe';
let GenericModalComponent = class GenericModalComponent {
    constructor() {
        this.modalClose = new EventEmitter();
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.inputElement) {
                this.inputElement.nativeElement.focus();
            }
        }, 10);
    }
    closeModal(datos) {
        const params = {
            nombrePopup: this.popupName,
            datosPopup: datos
        };
        this.modalClose.emit(params);
    }
};
GenericModalComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [])
], GenericModalComponent);
export { GenericModalComponent };
